@defer (on immediate) {
    @if (mode() === productSizeMode.SELECT) {
        <product-size-selector-select
            [sizes]="product()?.status?.selectedColor?.sizes"
            [uniqueSize]="uniqueSize"
            [product]="product()"
            (sizeSelectedEvent)="selectSize($event)"
        ></product-size-selector-select>
    } @else {
        <product-size-selector-horizontal
            [sizes]="_sizes"
            [isQuickPurchase]="isQuickPurchase()"
            [uniqueSize]="uniqueSize"
            (sizeSelectedEvent)="selectSize($event)"
        ></product-size-selector-horizontal>
    }
}
